import { Anchor, Box, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import * as React from 'react';
import { useMyNavigate } from '../router/createdRouter';

export const NotFoundComponent = () => {
    const navigate = useMyNavigate();
    return (
        <Box display={'flex'} w={'100%'} h={'100%'} style={{ overflowY: 'hidden' }}>
            <Box pos={'absolute'} top={'45%'} ta={'center'} w={'100%'}>
                <IconAlertTriangle size={20} style={{ transform: 'scale(5.5)', paddingBottom: 10 }} />
                <Text style={{ fontStyle: 'italic', fontSize: '32pt' }}>{'404'}</Text>
                <br />
                <Text style={{ fontStyle: 'italic' }}>This page could not be found.</Text>
                <br />
                <Anchor
                    onClick={() => {
                        navigate({
                            route: '/projects',
                            searchParams: {},
                        });
                    }}
                    c={'var(--mantine-text-secondary-color)'}
                >
                    <Text c={'var(--mantine-text-secondary-color)'} fw={700}>
                        Back to Projects
                    </Text>
                </Anchor>
            </Box>
        </Box>
    );
};


